import ProductBoostingV2Page from "@faire/prototype-playground/workspace/ac/product-boosting-v2";
import ProductBoostingV2M1Page from "@faire/prototype-playground/workspace/ac/product-boosting-v-2-m-1";
import ProductVideoTileReadinessAuditPage from "@faire/prototype-playground/workspace/ac/product-video-tile-readiness-audit";
import { lazy } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { withCompass } from "../../components/compass/withCompass";

const AdCarouselOnHomepagePage = withCompass(
  () => import("@faire/prototype-playground/workspace/ac/ad-carousel-homepage")
);
const AdCarouselOnHubsExplorationPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/ac/ad-carousel-on-hubs-exploration/Page")
);

const AdCarouselOnHubsXpM1Page = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/ac/ad-carousel-on-hubs-xp-m-1")
);
const BrandAdCarouselOnHubsPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/ac/brand-ad-carousel-on-hubs")
);
const AdBrandCartPage = withCompass(
  () => import("../../pages/AdBrandCartPage")
);
const AdBrandPagePage = withCompass(
  () => import("../../pages/AdBrandPagePage")
);
const AdCartListPage = withCompass(() => import("../../pages/AdCartListPage"));
const AdSearchBoxPage = withCompass(
  () => import("../../pages/AdSearchBoxPage")
);
const AdSearchResultsPage = withCompass(
  () => import("../../pages/AdSearchResultsPage")
);
const Ads2DControlsAlphaBetaPage = lazy(
  () => import("../../pages/Ads2DControlsAlphaBeta")
);
const Ads2DControlsPage = lazy(() => import("../../pages/Ads2DControlsPage"));
const VideoAdTilesPage = withCompass(
  () => import("../../pages/VideoAdTilesPage")
);
const VideoAdTilesHoverXpPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/ac/video-ad-tiles-hover-xp")
);
const VideoAdTilesHomepagePage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/ac/video-ad-tiles-homepage")
);
const VideoAdTilesM0XpPage = withCompass(
  () => import("@faire/prototype-playground/workspace/ac/video-ad-tiles-m0-xp")
);
const ReorganizeAdsAsCampaignsPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/ac/reorganize-ads-as-campaigns")
);
const SlideshowVideoAssetsPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/ac/slideshow-video-assets")
);

export function ArthurCheRoutes() {
  return (
    <Switch>
      <Route path="/ac/ad-brand-cart" component={AdBrandCartPage} />
      <Route path="/ac/ad-brand-page" component={AdBrandPagePage} />
      <Route
        path="/ac/ad-carousel-homepage"
        component={AdCarouselOnHomepagePage}
      />
      <Route
        path="/ac/ad-carousel-on-catnav"
        render={({ location }) => (
          <Redirect
            to={{
              pathname: "/ac/ad-carousel-on-hubs-exploration",
              search: location.search,
              hash: location.hash,
            }}
          />
        )}
      />
      <Route
        path="/ac/ad-carousel-on-hubs-exploration"
        component={AdCarouselOnHubsExplorationPage}
      />
      <Route
        path="/ac/ad-carousel-on-hubs-xp-m-1"
        component={AdCarouselOnHubsXpM1Page}
      />
      <Route path="/ac/ad-cart-list" component={AdCartListPage} />
      <Route path="/ac/ad-search-box" component={AdSearchBoxPage} />
      <Route path="/ac/ad-search-results" component={AdSearchResultsPage} />
      <Route
        path="/ac/ads-2d-controls-alpha-beta"
        component={Ads2DControlsAlphaBetaPage}
      />
      <Route path="/ac/ads-2d-controls" component={Ads2DControlsPage} />
      <Route path="/ac/brand-ad-carousel-on-hubs" component={BrandAdCarouselOnHubsPage} />
      <Route
        path="/ac/product-boosting-v-2-m-1"
        component={ProductBoostingV2M1Page}
      />
      <Route path="/ac/product-boosting-v2" component={ProductBoostingV2Page} />
      <Route
        path="/ac/product-video-tile-readiness-audit"
        component={ProductVideoTileReadinessAuditPage}
      />
      <Route
        path="/ac/reorganize-ads-as-campaigns"
        component={ReorganizeAdsAsCampaignsPage}
      />
      <Route
        path="/ac/slideshow-video-assets"
        component={SlideshowVideoAssetsPage}
      />
      <Route path="/ac/video-ad-tiles" component={VideoAdTilesPage} />
      <Route
        path="/ac/video-ad-tiles-hover-xp"
        component={VideoAdTilesHoverXpPage}
      />
      <Route
        path="/ac/video-ad-tiles-homepage"
        component={VideoAdTilesHomepagePage}
      />
      <Route path="/ac/video-ad-tiles-m0-xp" component={VideoAdTilesM0XpPage} />
    </Switch>
  );
}

export const slug = "ac";
